<template>
    <div class="technology">
        <div class="banner">
            <div class="title">TECHNOLOGY</div>
            <div class="subtitle">Our solutions are entirely dependent on the latest advancements in AI and cloud computing. This dual foundation makes BuildEffi AI uniquely positioned to transform the construction industry</div>
            <img class="bg" src="@/assets/technology/banner.png"/>
        </div>
        <div class="core">
            <div class="core-item-1">
                <div class="title">AI Core Engine</div>
                <div class="note">Uses machine learning to analyze millions of data points, delivering actionable insights that enhance decision-making.</div>
                <div class="mark">Uses machine learning to analyze millions of data points, delivering actionable insights that enhance decision-making.</div>
            </div>
            <div class="core-item-2">
                <div class="title">Cloud Platform</div>
                <div class="note">Provides real-time data access and collaboration for teams in any location.</div>
                <div class="mark">Ensures secure, scalable storage for projects of any size, with seamless integration across devices and tools.</div>
            </div>
            <div class="core-item-3">
                <div class="title">Integrated Ecosystem</div>
                <div class="note">Combines AI algorithms and cloud infrastructure to automate workflows and enable dynamic project updates.</div>
            </div>
            <img class="bg" src="@/assets/technology/core.png"/>
        </div>
        <div class="serve">
            <div class="title">INDUSTRIES WE SERVE</div>
            <div class="subtitle">BuildEffi AI delivers transformative solutions across diverse construction sectors, all powered by AI and<br/> cloud technology</div>
            <div class="serve-box">
                <div class="item">
                    <img src="@/assets/technology/item-1.png"/>
                    <div class="item-title">Commercial Construction</div>
                    <div class="item-note">Optimize resource planning, budgeting, and execution for large-scale developments.</div>
                </div>
                <div class="item">
                    <img src="@/assets/technology/item-2.png"/>
                    <div class="item-title">Infrastructure Projects</div>
                    <div class="item-note">Enhance efficiency and safety in public projects like roads, bridges, and railways.</div>
                </div>
                <div class="item">
                    <img src="@/assets/technology/item-3.png"/>
                    <div class="item-title">Residential Development</div>
                    <div class="item-note">Ensure precision and sustainability in housing projects of any scale.</div>
                </div>
                <div class="item">
                    <img src="@/assets/technology/item-4.png"/>
                    <div class="item-title">Industrial Construction</div>
                    <div class="item-note">Streamline complex workflows for factories, warehouses, and energy facilities.</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({

    })
}
</script>

<style scoped lang="scss">
.banner {
    position: relative;
    width: 100%;

    .bg {
        width: 100%;
    }

    .title {
        position: absolute;
        top: 295px;
        left: 519px;
        font-size: 56px;
        font-weight: 700;
        line-height: 60px;
        color: #ffffff;
    }

    .subtitle {
        position: absolute;
        top: 400px;
        left: 242px;
        width: 948px;
        font-size: 16px;
        line-height: 30px;
        text-align: center;
        color: #ffffff;
        text-transform: capitalize;
    }
}

.core {
    position: relative;
    width: 100%;
    padding: 100px 220px;

    .bg {
        width: 100%;
        object-fit: contain;
    }

    .core-item-1 {
        position: absolute;
        top: 200px;
        left: 584px;
        color: #ffffff;

        .title {
            font-size: 24px;
            font-weight: 700;
            line-height: 44px;
            margin-bottom: 14px;
        }

        .note {
            width: 480px;
            font-size: 14px;
            font-weight: 400;
            line-height: 26px;
            margin-bottom: 11px;
        }

        .mark {
            width: 480px;
            font-size: 14px;
            font-weight: 400;
            line-height: 26px;
        }
    }

    .core-item-2 {
        position: absolute;
        top: 525px;
        left: 335px;
        color: #ffffff;

        .title {
            font-size: 24px;
            font-weight: 700;
            line-height: 44px;
            margin-bottom: 14px;
        }

        .note {
            width: 412px;
            font-size: 14px;
            font-weight: 400;
            line-height: 26px;
            margin-bottom: 10px;
        }

        .mark {
            width: 357px;
            font-size: 14px;
            font-weight: 400;
            line-height: 26px;
        }
    }

    .core-item-3 {
        position: absolute;
        top: 855px;
        left: 604px;
        color: #ffffff;

        .title {
            font-size: 24px;
            font-weight: 700;
            line-height: 44px;
            margin-bottom: 14px;
        }

        .note {
            width: 383px;
            font-size: 14px;
            font-weight: 400;
            line-height: 26px;
            margin-bottom: 10px;
        }
    }
}

.serve {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 1266px;
    background: url("../assets/technology/serve.png") no-repeat 100%;

    .title {
        padding-top: 50px;
        font-size: 40px;
        font-weight: 700;
        line-height: 73px;
        color: #ffffff;
        text-align: center;
        margin-bottom: 32px;
    }

    .subtitle {
        width: 100%;
        font-size: 16px;
        line-height: 30px;
        color: #ffffff;
        text-align: center;
        text-transform: capitalize;
        margin-bottom: 85px;
    }

    .serve-box {
        display: flex;
        flex-wrap: wrap;
        width: 970px;
        gap: 54px;

        .item {
            > img {
                width: 458px;
                height: 270px;
                object-fit: contain;
                margin-bottom: 32px;
            }

            &-title {
                font-size: 20px;
                font-weight: 700;
                line-height: 36px;
                color: #ffffff;
                margin-bottom: 20px;
            }

            &-note {
                font-size: 14px;
                font-weight: 400;
                line-height: 26px;
                color: #ffffff;
                text-transform: capitalize;

                &:nth-child(odd) {
                    width: 398px;
                }

                &:nth-child(even) {
                    width: 367px;
                }
            }
        }
    }
}
</style>